import React, { useState, useEffect } from "react";
import { AL } from "./al";
import App from "./App";
import "./authentication.css";
import { McButton } from "@maersk-global/mds-react-wrapper";


const Auth = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        if (AL.isTokenValid("access_token", 10000)) {
          setUser(AL.storage.id_token_claims);
        } else if (AL.isTokenValid("refresh_token", 10000)) {
          await AL.refreshTokens({});
          setUser(AL.storage.id_token_claims);
        } else {
          // ✅ Do NOT redirect here, just show login screen
          setUser(null);
        }
      } catch (err) {
        console.error("Auth check failed:", err);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  if (loading) {
    return <div>Loading authentication...</div>;
  }
  
  if (!user) {
    return (
      <div className='mds'>
      <div className="login-page">
          <div className="sign-in-card">
            <div className="sign-in-header">
              <h1 className="sign-in-title mds-headline--medium">Welcome to Maersk Portal</h1>
              <p className="sign-in-subtitle">Unplanned Charges Management System</p>
            </div>

            <div className="sign-in-content">
              <McButton

                fit="medium"
                appearance="secondary"
                onClick={() =>
                  AL.loginRedirect({ scopes: ["openid", "profile", "email", "roles"] })
                }
              >
                Sign In
              </McButton>
              <div className="registration-links">
              <p>Don't have an account?</p>
               <a href={process.env.REACT_APP_CIAM_REGISTRATION_URL}
                target="_blank"
              >
                 Register
              </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // ✅ User authenticated
  return <App />;
};

export default Auth;
